@if (isLoading()) {
  <div class="loading-spinner">
    <app-spinner />

    <div class="redirection-notice">
      <p>Redirecting to</p>

      <img class="footer-logo" src="assets/svg/transend-logo-wide.svg" alt="Transend" />
    </div>
  </div>
} @else {
  <div class="layout">
    <header class="header" [style.background-color]="brandColor()">
      <app-logo class="header-logo" />
    </header>

    <main class="content">
      @if (!hideGoBackButton()) {
        <div class="actions">
          <button class="go-back-btn" type="button" (click)="onGoBack()">
            <img src="assets/svg/arrow-back.svg" alt="" width="20" height="20" />
            <span>Go back</span>
          </button>
        </div>
      }

      <router-outlet />

      <footer class="footer">
        <span class="footer-text">Powered by</span>
        <img class="footer-logo" src="assets/svg/transend-logo-wide.svg" alt="Transend" />
      </footer>
    </main>
  </div>
}
